import { render, staticRenderFns } from "./TransferCartRoute.vue?vue&type=template&id=7b067935&"
import script from "./TransferCartRoute.vue?vue&type=script&lang=ts&"
export * from "./TransferCartRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports